module.exports = require("./Gender")
